import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

export interface UserState {
    detail: any,
    credit: number
}

const initialState: UserState = {
    detail: [],
    credit: 0
};

export const User = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setCredit: (state, action: PayloadAction<number>) => {
            state.credit = state.credit + action.payload;
        },
        clearCredit: (state) => {
            state.credit = 0;
        },
        setUser: (state, action: PayloadAction<number>) => {
            state.detail = action.payload;
        },
    },
})

export const {setCredit, clearCredit, setUser } = User.actions

export default User.reducer
